"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FeedbackBenefitDialogController = require("./FeedbackBenefitDialogController");
Object.keys(_FeedbackBenefitDialogController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeedbackBenefitDialogController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeedbackBenefitDialogController[key];
    }
  });
});
